import { render, staticRenderFns } from "./contactCen.vue?vue&type=template&id=a8f97b02&scoped=true&"
import script from "./contactCen.vue?vue&type=script&lang=js&"
export * from "./contactCen.vue?vue&type=script&lang=js&"
import style1 from "./contactCen.vue?vue&type=style&index=1&id=a8f97b02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f97b02",
  null
  
)

export default component.exports